import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withMetadata,
    withSearchFilter,
} from '@pf/shared-utility';
import {
    WarehouseCreate,
    WarehouseDto,
    WarehouseRead,
    WarehouseSearchParams,
} from '../../entities/warehouse.dto';
import {
    CustomFieldMetadataMap,
    DefaultLocationFragmentMetadataMap,
    ResourceAuthSymbol,
} from '@pf/shared/util-platform';
import { ZoneMetadataMap } from '../zones/zone.mapping-profile';

const symbols = entitySymbols(PFWmsEntities.Warehouse);

withDefaultEntityMetadata<WarehouseDto>(symbols.dto, {
    name: String,
    code: String,
    description: String,
    locationId: String,
    location: DefaultLocationFragmentMetadataMap.symbols.dto,
    resourceAuth: ResourceAuthSymbol,
    customFields: [CustomFieldMetadataMap.symbols.entity],
    zones: [ZoneMetadataMap.symbols.entity],
    settings: Object,
});

withDefaultEntityMetadata<WarehouseRead>(symbols.entity, {
    code: String,
    name: String,
    description: String,
    locationId: String,
    location: DefaultLocationFragmentMetadataMap.symbols.entity,
    resourceAuth: ResourceAuthSymbol,
    customFields: [CustomFieldMetadataMap.symbols.entity],
    zones: [ZoneMetadataMap.symbols.entity],
    settings: Object,
});

withMetadata<WarehouseCreate>(symbols.createBody, {
    code: String,
    description: String,
    locationId: String,
    name: String,
    resourceAuth: ResourceAuthSymbol,
    settings: Object,
});

withDefaultSearchParamsMetadata<WarehouseSearchParams>(symbols.searchParams, {
    name: String,
    code: String,
});

export const WarehouseMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<WarehouseRead, WarehouseDto>(
            mapper,
            symbols.entity,
            symbols.dto
        );
        createMap<WarehouseDto, WarehouseRead>(
            mapper,
            symbols.dto,
            symbols.entity
        );
        createMap<WarehouseDto, WarehouseCreate>(
            mapper,
            symbols.dto,
            symbols.createBody
        );
        createMap<IQueryParams<WarehouseDto>, WarehouseSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withSearchFilter('name'),
            ...withDefaultSearchParamsMappingConfiguration()
        );

        DefaultLocationFragmentMetadataMap.profile(mapper);
        CustomFieldMetadataMap.profile(mapper);
        ZoneMetadataMap.profile(mapper);
    },
};
